export const LOAD_NOTES_SUCCESS = 'LOAD_NOTES_SUCCESS'
export const LOAD_SINGLE_NOTE_SUCCESS = 'LOAD_SINGLE_NOTE_SUCCESS'
export const UPDATE_NOTE_SUCCESS = 'UPDATE_NOTE_SUCCESS'
export const COPY_NOTE_SUCCESS = 'COPY_NOTE_SUCCESS'
export const DELETE_NOTES_SUCCESS = 'DELETE_NOTES_SUCCESS'
export const CREATE_NOTES_SUCCESS = 'CREATE_NOTES_SUCCESS'
